export default __webpack_public_path__ + "static/media/acesso-cidadao-logo.3ef2dc14.ico";